import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1093cd0f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "prize-pool-view" }
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "header-right" }
const _hoisted_4 = { class: "page-title" }
const _hoisted_5 = { class: "prize-display" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "prize-label" }, "Current Prize", -1))
const _hoisted_7 = { class: "prize-amount" }
const _hoisted_8 = { class: "cards-row" }
const _hoisted_9 = { class: "quick-amounts" }
const _hoisted_10 = { class: "donor-fields" }
const _hoisted_11 = { id: "paypal-button-container" }
const _hoisted_12 = { class: "loading-placeholder" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Loading PayPal...", -1))
const _hoisted_14 = {
  key: 0,
  class: "empty-state"
}
const _hoisted_15 = {
  key: 1,
  class: "donations-summary"
}
const _hoisted_16 = { class: "summary-stat" }
const _hoisted_17 = { class: "summary-value" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "summary-label" }, "donors", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "summary-divider" }, null, -1))
const _hoisted_20 = { class: "summary-stat" }
const _hoisted_21 = { class: "summary-value" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "summary-label" }, "contributed", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: "/bgg_fgc",
        class: "back-link"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, { size: "18" }, {
            default: _withCtx(() => [
              _createTextVNode("mdi-arrow-left")
            ]),
            _: 1
          }),
          _createTextVNode(" BGG FGC ")
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.gameTitle) + " Prize Pool", 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, "$" + _toDisplayString(_ctx.currentTotal.toFixed(2)), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_v_card, {
        class: "donate-card",
        elevation: "4"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, null, {
            default: _withCtx(() => [
              _createTextVNode("Support the Prize Pool")
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.donationAmount,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.donationAmount) = $event)),
                label: "Donation Amount",
                type: "number",
                prefix: "$",
                min: "1",
                max: "500",
                step: "1",
                density: "compact",
                class: "donation-input",
                hint: "$1 – $500"
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_9, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList([5, 10, 25, 50], (amount) => {
                  return _createVNode(_component_v_btn, {
                    key: amount,
                    size: "small",
                    variant: "outlined",
                    onClick: ($event: any) => (_ctx.donationAmount = amount.toString())
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" $" + _toDisplayString(amount), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                }), 64))
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_v_text_field, {
                  modelValue: _ctx.donorName,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.donorName) = $event)),
                  label: "Your Name (leave blank to donate anonymously)",
                  density: "compact",
                  class: "donor-name-input"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_textarea, {
                  modelValue: _ctx.donationNote,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.donationNote) = $event)),
                  label: "Message (optional)",
                  rows: "1",
                  density: "compact",
                  class: "donor-note-input"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_v_progress_circular, {
                    indeterminate: "",
                    color: "primary"
                  }),
                  _hoisted_13
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_card, {
        class: "donations-card",
        elevation: "4"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, null, {
            default: _withCtx(() => [
              _createTextVNode("Donations")
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              (_ctx.donations.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, " No donations yet. Be the first! "))
                : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.donations.length), 1),
                      _hoisted_18
                    ]),
                    _hoisted_19,
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("span", _hoisted_21, "$" + _toDisplayString(_ctx.donationsTotal.toFixed(2)), 1),
                      _hoisted_22
                    ])
                  ]))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}